<template>
    <!-- 进度条 -->
    <div class="progressContainer">
        <div
            class="progressItem"
            :style="{ width: barwidth * 33 + '%' }"
            ref="progress"
        ></div>
    </div>
</template>
<script>
// import {mapGetters} from 'vuex'
export default {
    name: "progressBar",
    props: ["barwidth"],
    computed: {
        // ...mapGetters([
        //     'level'
        // ])
    },
    methods: {
        progressColor() {
            if (this.barwidth == 2) {
                this.$refs.progress.style.background = "#FFDEAD";
            }
            if (this.barwidth == 3) {
                this.$refs.progress.style.background = "#98FB98";
            }
        }
    },
    mounted() {
        this.progressColor();
    },
    updated() {
        this.progressColor();
    }
};
</script>
<style lang="scss" scoped>
.progressContainer {
    position: relative;
    height: 15px;
    width: 96%;
    background-color: rgb(242, 242, 242);
    border-radius: 8px;
}
.progressItem {
    position: absolute;
    height: 15px;
    line-height: 10px;
    border-radius: 8px;
    background-color: rgb(255, 204, 204);
}
b {
    color: #fff;
    font-weight: 100;
    font-variant-position: 12px;
    position: absolute;
    left: 40%;
}
</style>
